import { identity, map, pickBy } from 'lodash';
import { Meta, Title } from '@angular/platform-browser';
import { of, Subject, switchMap, takeUntil } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { Component, ChangeDetectorRef, Renderer2, Inject, PLATFORM_ID } from '@angular/core';

import { LandingPagesWithoutTranslationType, LandingPageTypeEnum, SlidesType } from '@sifca-monorepo/ecommerce-generator';

import { LandingPagesService, SeoService, SlidesService, SharedService } from '../services';

@Component({
  template: '',
})
export class BasePageComponent {
  protected unsubscribeAll: Subject<any> = new Subject<any>();

  protected slides: SlidesType[] = [];

  seo: any;
  posId: string = '';
  landingPage: LandingPagesWithoutTranslationType;
  landingPages: LandingPagesWithoutTranslationType[];

  constructor(
    protected renderer: Renderer2,
    protected metaTagService: Meta,
    protected seoService: SeoService,
    protected titleTagService: Title,
    protected sharedService: SharedService,
    protected slidesService: SlidesService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected landingPagesService: LandingPagesService,
    @Inject(DOCUMENT) protected document: Document,
    @Inject(PLATFORM_ID) protected platformId: Object,
    protected landingPageType: LandingPageTypeEnum,
  ) {
    this.sharedService.posId$.pipe(takeUntil(this.unsubscribeAll)).subscribe((posId) => {
      this.posId = posId;
    });
    this.landingPagesService.landingPages$.pipe(takeUntil(this.unsubscribeAll)).subscribe((res) => {
      this.landingPage = res?.objects?.[0];
      this.landingPages = res?.objects;
      this.changeDetectorRef.markForCheck();
    });
    this.landingPagesService
      .findLandingPagesByTargetAndTypePaginated([landingPageType])
      .pipe(
        switchMap((response) => {
          if (response) {
            this.landingPages = response.objects;
            if (this.landingPages?.length) {
              return this.seoService.getPagesSEOJSON(this.landingPages[0]?.id);
            }
          }
          return of(null);
        }),
      )
      .subscribe((res) => {
        this.seo = res;
        if (this.seo?.title) {
          this.titleTagService.setTitle(this.seo?.title);
        }
        this.sharedService.tags$ = [
          ...this.metaTagService.addTags(
            map(this.seo?.metas, (meta) => pickBy(meta, identity)).filter(
              (meta: any) => `${meta?.name ?? ''}`.toLowerCase() !== 'viewport' && meta?.charset === undefined,
            ),
          ),
          { charset: 'UTF-8' },
        ];
          this.sharedService.links$ = map(this.seo?.links, (seoLink) => {
            const link = this.renderer.createElement('link');
            if (seoLink.sizes) {
              link.sizes = seoLink.sizes;
            }
            if (seoLink.href) {
              link.href = seoLink.href;
            }
            if (seoLink.rel) {
              link.rel = seoLink.rel;
            }
            this.renderer.appendChild(this.document.head, link);
            return link;
          });
        this.changeDetectorRef.markForCheck();
      });
    this.slidesService.getSlides(this.posId).subscribe();
    this.slidesService.slides$.pipe(takeUntil(this.unsubscribeAll)).subscribe((slides: SlidesType[]) => {
      if (slides) {
        this.slides = slides;
        this.handleSlides();
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  protected handleSlides(): void {
    // Implement slide handling logic in the derived components.
  }

  ngOnDestroy() {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
